const FeaturedTopics: React.FC = () => {
  return (
    <div className="featured-topics-page-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132; Featured Topics
      </p>
      <h2 className="help-heading">Featured Topics</h2>
      <p>
        <a href="/featured-topics/tabs" className="getting-started-title">
          Tabs on the home page
        </a>
      </p>
      <p>
        <a href="/featured-topics/navigate" className="getting-started-title">
          How do I navigate the company panel?
        </a>
      </p>
      <p>
        <a href="/featured-topics/acronyms" className="getting-started-title">
          Acronyms used on CEO.CA
        </a>
      </p>
    </div>
  );
};

export default FeaturedTopics;
